import { useEffect, useRef } from 'react';

import useTile from '../../components/Tile/hooks/useTile';

type Args = {
  tileState: ReturnType<typeof useTile>;
};

const useRequiredTiles = ({ tileState }: Args) => {
  const effectRan = useRef(false);

  useEffect(() => {
    if (effectRan.current) return;

    const requiredTiles = tileState.tiles.filter((item) =>
      ['payment-cash', 'payment-external-terminal'].includes(item.action),
    );

    tileState.setTilesList(requiredTiles);

    effectRan.current = true;
  }, [tileState]);
};

export default useRequiredTiles;
